/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Preview_LabelInputs */

const en_us2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image preview`)
};

const pt_br2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévia da imagem`)
};

const es_419_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de la imagen`)
};

const pt_pt2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da imagem`)
};

const fr_fr2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu de l'image`)
};

const de_de2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildvorschau`)
};

const it_it2_share_preview_label = /** @type {(inputs: Share_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dell'immagine`)
};

/**
* | output |
* | --- |
* | "Image preview" |
*
* @param {Share_Preview_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_preview_label = /** @type {((inputs?: Share_Preview_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Preview_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_preview_label(inputs)
	if (locale === "es-419") return es_419_share_preview_label(inputs)
	if (locale === "pt-PT") return pt_pt2_share_preview_label(inputs)
	if (locale === "fr-FR") return fr_fr2_share_preview_label(inputs)
	if (locale === "de-DE") return de_de2_share_preview_label(inputs)
	if (locale === "it-IT") return it_it2_share_preview_label(inputs)
	return en_us2_share_preview_label(inputs)
});
export { share_preview_label as "share.preview_label" }